import { debounce } from "lodash";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router";
import Actions from "../../components/Common/Actions";
import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../components/Common/Buttons/FilledButton";
import DoctorsFilterOptions from "../../components/Common/CommonFilterOptions";
import NavBarTitles from "../../components/Common/TabBar";
import ListPageLayout from "../../components/Layout";
import "./index.scss";

const AddNewClinic = () => {
  const navigate = useNavigate();
  const addNewClinicProfile = {
    id: "addnewpost",
    onClick: () => navigate("/add-new-clinic-form"),
    style: { width: "240px" },
    label: "Add New Clinic/Hospital Profile",
  };

  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("newest");
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortName, setSortName] = useState("Newest First");

  const [sortshow, setSortShow] = useState(false);
  const [textcolor, setTextColor] = useState(0);
  const [filtershow, setFilterShow] = useState(false);
  const [, setSubmitFilter] = useState(false);
  const [spldata, setSplData] = useState([]);
  const [statusdata, setStatusData] = useState([]);
  const [isChecked] = useState(true);
  const [location, setLocation] = useState("");

  const primaryspl = [
    {
      text: "Andrology",
    },
    {
      text: "Ayurveda",
    },
    {
      text: "Allergist",
    },
    {
      text: "Bariatrics",
    },
    {
      text: "Cardiology",
    },
    {
      text: "Cosmetology",
    },
    {
      text: "Dentistry",
    },
  ];

  const status = [
    {
      text: "Active",
    },
    {
      text: "Inactive",
    },
  ];

  const data = [
    {
      sno: "1",
      name: "Rk General Clinic",
      docname: ["Anand K", "Girish M", "Manoj Kumar L"],
      location: "Ganapathy",
      pincode: "641 006",
      photos: "",
      status: "Verified",
      spl: "Genereal Physician",
      license: "TN69241219",
      logo: "",
      time: [
        "09:30 AM - 11:30 AM",
        "12:00 PM - 02:30 PM",
        "03:00 PM - 06:00 PM",
        "06:30 PM - 12:00 AM",
        "12:00 AM - 07:30 AM",
      ],
      map: "http://www.khnishivs.vcn",
    },
  ];

  const breadcrumbsList = useMemo(
    () => [
      {
        text: "Clinic & Hospital",
        link: "/add-new-retail-pharmacy",
      },
      { text: "List of Active Clinic & Hospitals", link: "" },
    ],
    []
  );

  const healthArticleNavData = [
    {
      name: "Active Clinic & Hospitals",
      navigatePath: "/add-new-clinic",
    },
    {
      name: "Doctors in In-clinic Appointments",
      navigatePath: "/doctor-inclinic-appointment",
    },
  ];

  // SEARCH + SORT + PAGINATION
  const filteredSortedData = useMemo(() => {
    let temp = [...data];

    // Search
    if (search) {
      const lowerSearch = search.toLowerCase();
      temp = temp.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(lowerSearch)
        )
      );
    }

    // Sort
    switch (sort) {
      case "newest":
        temp.sort((a, b) => b.sno.localeCompare(a.sno));
        break;
      case "oldest":
        temp.sort((a, b) => a.sno.localeCompare(b.sno));
        break;
      case "ascending":
        temp.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "descending":
        temp.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }

    return temp;
  }, [search, sort]);

  const totalItems = filteredSortedData.length;
  const totalPages = Math.ceil(totalItems / limit);
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * limit;
    const end = start + limit;
    return filteredSortedData.slice(start, end);
  }, [filteredSortedData, currentPage, limit]);

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
    setSortName(
      {
        newest: "Newest First",
        oldest: "Oldest First",
        ascending: "Alphabetic A-Z",
        descending: "Alphabetic Z-A",
      }[selectedSort] || "Sort by"
    );
  };

  const debouncedSearch = debounce((value) => {
    setSearch(value);
    setCurrentPage(1);
  }, 500);

  const onChangeSearch = (value) => debouncedSearch(value);

  const handlePageChange = (page) => setCurrentPage(page);

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewClinicProfile} />}
      titles={<NavBarTitles titles={healthArticleNavData} />}
      totalCount={totalItems}
      pagination={{
        currentPage,
        skip: (currentPage - 1) * limit,
        limit,
        totalPages,
        onPageChange: handlePageChange,
      }}
      filters={
        <DoctorsFilterOptions
          limit={limit}
          setLimit={setLimit}
          search={search}
          onChange={onChangeSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          showFilter={false}
        />
      }
      tableProps={{
        columns: [
          {
            title: "S.No",
            dataIndex: "sno",
            key: "sno",
            render: (text, record, index) => Number(0) + (index + 1),
            width: 80,
          },
          {
            title: "Name of Clinic / Hospital",
            dataIndex: "name",
            key: "name",
            width: 200,
          },
          {
            title: "Concerned Doctor's Name",
            dataIndex: "docname",
            key: "docname",
            render: (names) =>
              Array.isArray(names) ? names.join(", ") : names,
            width: 200,
          },
          {
            title: "Location of Clinic / Hospital",
            dataIndex: "location",
            key: "location",
            width: 150,
          },
          {
            title: "Pincode of Clinic / Hospital",
            dataIndex: "pincode",
            key: "pincode",
            width: 150,
          },
          {
            title: "Clinic / Hospital Photos",
            dataIndex: "photos",
            key: "photos",
            render: (photos) =>
              photos && (
                <img
                  src={photos}
                  alt="Clinic"
                  style={{ width: 50, height: 50 }}
                />
              ),
            width: 150,
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
            width: 100,
          },
          {
            title: "Specialisation",
            dataIndex: "spl",
            key: "spl",
            width: 150,
          },
          {
            title: "License / Registration Number",
            dataIndex: "license",
            key: "license",
            width: 150,
          },
          {
            title: "Logo of Clinic / Hospital",
            dataIndex: "logo",
            key: "logo",
            render: (logo) =>
              logo && (
                <img src={logo} alt="Logo" style={{ width: 50, height: 50 }} />
              ),
            width: 150,
          },
          {
            title: "Timings",
            dataIndex: "time",
            key: "time",
            render: (times) =>
              Array.isArray(times) ? times.join(", ") : times,
            width: 200,
          },
          {
            title: "Google Map Location Mark",
            dataIndex: "map",
            key: "map",
            width: 150,
          },
          {
            title: "Actions",
            key: "actions",
            width: 400,
            render: (_, record) => (
              <Actions
                isEdit={true}
                isTrack={true}
                isView={true}
                isDelete={true}
                onClickTrack={() => navigate("/clinic-track")}
                onClickView={() => navigate("/view-clinic-form")}
                onClickEdit={() => navigate("/edit-clinic-form")}
              />
            ),
          },
        ],
        dataSource: paginatedData,
        bordered: true,
        scroll: { x: "max-content" },
        className: "mx-3 pt-2 table-scrollable masterList_table",
        pagination: false,
      }}
    />
  );
};

export default AddNewClinic;
